import type { UpdatePropertyMutationRequest, UpdatePropertyMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'

export function updatePropertyHandler() {
  return http.put<
    never,
    UpdatePropertyMutationRequest,
    UpdatePropertyMutationResponse
  >('http://localhost:3000/api/v1/property/:id', () => {
    return HttpResponse.json({
      id: '1',
    })
  })
}
